import React from 'react';

const Footer = () => (
  <footer style={styles.footerContainer}>
    <div style={styles.contentWrapper}>
      <p style={styles.copyright}>
        By using this website you are governed by our{' '}
        <a href="/legal" style={styles.link}>
          Terms &amp; Conditions and Privacy Policy
        </a>
      </p>
      <p style={styles.copyright}>
        Copyright © 2026 Powered by{' '}
        <a href="https://omnevu.com" target="_blank" rel="noopener noreferrer" style={styles.link}>
          omnevu.com
        </a>
      </p>
    </div>
  </footer>
);

const styles = {
  footerContainer: {
    background: 'linear-gradient(to right, #03a9f4, #7e57c2)',
    color: 'white',
    padding: '10px 20px',
    marginTop: 'auto',
    width: '100%',
    boxSizing: 'border-box',
    position: 'fixed',
    left: 0,
    bottom: 0,
    zIndex: 20,
  },
  contentWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '12px 20px',
  },
  copyright: { margin: 0, fontSize: '12px', color: 'white' },
  link: { color: 'white', textDecoration: 'underline', fontSize: '12px', cursor: 'pointer' },
};

export default Footer;
